import type { PanelUserDto } from "@/lib/schemas/auth";
import type { PanelUser } from "@/lib/domain/models";

export function toPanelUser(dto: PanelUserDto): PanelUser {
  return { id: dto.id, email: dto.email, displayName: dto.name, role: dto.role, capabilities: new Set(dto.capabilities), mfaRecent: dto.mfa_recent };
}
